import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-labour-job',
  templateUrl: './labour-job.component.html',
  styleUrls: ['./labour-job.component.css']
})
export class LabourJobComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
